import { Injectable } from '@angular/core';
import { AuthTenant } from '../enums/auth-tenant.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthTenantContextService {
  private selectedTenant: AuthTenant = AuthTenant.Primary; // Default to primary
  private readonly STORAGE_KEY = 'selectedAuthTenant';

  constructor() {
    this.loadSelectedTenant();
  }

  setSelectedTenant(tenant: AuthTenant): void {
    this.selectedTenant = tenant;
    localStorage.setItem(this.STORAGE_KEY, tenant);
  }

  getSelectedTenant(): AuthTenant {
    return this.selectedTenant;
  }

  clearSelectedTenant(): void {
    this.selectedTenant = AuthTenant.Primary;
    localStorage.removeItem(this.STORAGE_KEY);
  }

  private loadSelectedTenant(): void {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    if (saved && Object.values(AuthTenant).includes(saved as AuthTenant)) {
      this.selectedTenant = saved as AuthTenant;
    }
  }
}
